import React, { useState } from "react";
import PropTypes from "prop-types";

import { Dialog } from "@headlessui/react";
import Button from "./Button";

export default function ConfirmationButton({
  children,
  onConfirm,
  data,
  color,
  confirmationTitle = "Demande de confirmation",
  confirmationBody,
  icon,
}) {
  const [isOpen, setIsOpen] = useState(false);

  let className = "";

  switch (color) {
    default:
    case "success":
      className = "bg-success hover:bg-success/90";
      break;
    case "danger":
      className = "bg-danger hover:bg-danger/90";
      break;
  }

  const confirm = () => {
    setIsOpen(false);

    if (onConfirm && typeof onConfirm === "function") {
      onConfirm(data);
    }
  };

  return (
    <>
      {icon ? (
        <div
          className={`${className} w-8 h-8 rounded-lg flex justify-center items-center transition ease-in-out duration-200 font-bold text-2xl cursor-pointer`}
          onClick={() => setIsOpen(true)}
        >
          {icon}
        </div>
      ) : (
        <div
          className={`${className} px-2 py-1 rounded-lg ease-in-out duration-200 cursor-pointer`}
          onClick={() => setIsOpen(true)}
        >
          {children}
        </div>
      )}

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-10"
      >
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel>
            <div className="bg-slate-900 border border-slate-700 p-4 rounded-xl text-white">
              <Dialog.Title className="text-xl">
                {confirmationTitle}
              </Dialog.Title>
              <Dialog.Description className="py-4">
                {confirmationBody}
              </Dialog.Description>

              <div className="flex justify-between">
                <Button color="light" size="s" onClick={() => setIsOpen(false)}>
                  Annuler
                </Button>
                <Button size="s" className={`${className}`} onClick={confirm}>
                  Confirmer
                </Button>
              </div>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
}

ConfirmationButton.propTypes = {
  onConfirm: PropTypes.func,
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["success", "danger"]),
  confirmationTitle: PropTypes.string,
  confirmationBody: PropTypes.string.isRequired,
  icon: PropTypes.element,
};

ConfirmationButton.defaultProps = {
  color: "success",
  confirmationTitle: "Demande de confirmation",
};
